import { Buttons, ButtonsData, ButtonsWidgetSettings, ButtonsWidget } from "../Control/Buttons";
import { ReactNode, ReactElement } from 'react';
import _ from 'lodash';
import * as WidgetsThingsStructs from "../WidgetsThingsStructs";
import { ButtonThemeType } from "../UserInput/FormStruct";
import { ButtonLabelPosition, ButtonValueType } from "../../../Primitive/Button";
import { IWidgetThingsClass } from "../Utils/IWidgetThingsClass";
import { getRandomSmallKey, isDefined, IsNullOrEmpty } from '@Utils/Micro';
import { WebNode } from '@API/WebNode';
import { WebThing, WebThingPort } from '@API/WebThing';
import { WebThingPortType } from '@API/WebNodeTypes';
import { Plegma } from '@API/Api';
import { IWidgetDescription, WidgetDescriptionToPlegmaThing } from '@UI/Widgets/WidgetStructs';
// =======================================================================================================
// Singleton Button Widget
export class ButtonSingletonWidget extends IWidgetThingsClass<ButtonsData> {
    // ------------------------------------------------------------------------------------------------
    public Render(): ReactNode {
        return <Buttons />;
    }
    // ------------------------------------------------------------------------------------------------
    public RenderWidgetSettings(key: string, width: number, height: number): ReactElement<any> {
        const parent = this.Parent;
        return <ButtonsWidgetSettings
            key={"Settings-" + key}
            width={width}
            height={height}
            WidgetData={_.cloneDeep(this.WidgetData)} // copy of the data and is return the copy in the update cb
            WidgetDefaultValues={_.cloneDeep(this.Description.DefaultValues)}
            onWidgetDataUpdate={(d) => this.WidgetDataUpdate(d)}
            ThingKey={this.ThingKey}
            NodeKey={this.NodeKey}
            SettingListToolbar={isDefined(parent) ? parent.SettingsListToolbar : null}
        />;
    }
    // ------------------------------------------------------------------------------------------------
    updateThing() {
        let wData = this.WidgetData;
        let webNode = WebNode.GetInstanceKey(this.NodeKey);
        let thing = webNode.GetThing(this.ThingKey);

        // Clean old ports
        thing.Ports = {};

        // Add the ports
        _.forEach(wData.Buttons, btn => {
            thing.AddPort(new WebThingPort(
                {
                    Name: btn.Label,
                    PortKey: btn.Key,
                    Type: Plegma.ePortType.Boolean,
                    ioDirection: Plegma.ioPortDirection.Output,
                    State: "False"
                },
                WebThingPortType.Trigger), false);
        });

        webNode.GetModule(this.WebModuleKey).UpdateThing(thing);
    }
    // ------------------------------------------------------------------------------------------------
    initThing() {
        let wData = this.WidgetData;

        // Thing description
        let plegmaThing = WidgetDescriptionToPlegmaThing(this.Description);

        // Ports
        let ports: WebThingPort[] = [];
        _.forEach(wData.Buttons, btn => {
            ports.push(new WebThingPort(
                {
                    Name: btn.Label,
                    PortKey: btn.Key,
                    Type: Plegma.ePortType.Boolean,
                    ioDirection: Plegma.ioPortDirection.Output,
                    State: "False"
                },
                WebThingPortType.Trigger
            ));
        });

        // Create the thing
        let thing = new WebThing(this.WebModule, plegmaThing, ports);
        this.ThingKey = thing.ThingKey;
    }
    // ------------------------------------------------------------------------------------------------
    public static GetDefaultWidgetDataStatic(): ButtonsData {
        return {
            Buttons: [{
                Key: "1_" + getRandomSmallKey(),
                Value: "",
                Label: "",
                LabelPosition: ButtonLabelPosition.bottom,
                LabelAlign: "center",
                Tooltip: null,
                Type: ButtonValueType.Text,
                ThemeType: ButtonThemeType.Default,
                Flat: false,
                Uppercase: true,
                Color: 'rgb(0, 188, 212)',
                FontColor: 'white',
                ShowBubble: false,
                BubbleBackgroundColor: '#D0021B',
                BubbleColor: 'white',
                BubbleSize: 20,
                BubbleContent: '1'
            }],
            IsSingleton: true,
            FillWidget: true,
            CanvasLayoutDesc: null,
            MaxFontSize: 14,
            BorderRadius: 2,
            OnHoverFontColor: null,
            OnHoverBackgroundColor: null
        };
    }
    // ------------------------------------------------------------------------------------------------
    public GetDefaultWidgetData() { return ButtonSingletonWidget.GetDefaultWidgetDataStatic(); }
    // ------------------------------------------------------------------------------------------------
    public static GetWidgetDesc(): IWidgetDescription {
        let data: ButtonsData = ButtonSingletonWidget.GetDefaultWidgetDataStatic();
        data.Buttons[0].Label = "Button"
        return {
            Title: "Button",
            WidgetTitle: "",
            Key: "ButtonSingletonWidget",
            Type: "ButtonSingletonWidget",
            Data: data,
            MinH: 1,
            MinW: 1,
            ShowExtraMenu: false,
            DefiesGrid: true,
            WidgetNoBackground: true,
            IconURI: WidgetsThingsStructs.IconURIPath + "/png/button_singleton.png"
        };
    }
    // ------------------------------------------------------------------------------------------------
    MigrateDefaultWidgetData(widgetData: ButtonsData): ButtonsData {
        let button = widgetData.Buttons[0];
        if (isDefined(button)) {
            if (!isDefined(button.Type))
                button.Type = ButtonValueType.Text;

            if (!isDefined(button.ThemeType))
                button.ThemeType = ButtonThemeType.Default;

            if (!isDefined(button.Flat))
                button.Flat = false;

            if (!isDefined(button.Uppercase))
                button.Uppercase = true;

            if (!isDefined(button.Color))
                button.Color = 'rgb(0, 188, 212)';

            if (!isDefined(button.FontColor))
                if (button.Flat)
                    button.FontColor = button.Color;
                else
                    button.FontColor = 'white';

            if (!isDefined(button.LabelPosition))
                button.LabelPosition = ButtonLabelPosition.bottom;

            if (!isDefined(button.Label) && button.Type == ButtonValueType.Text)
                button.Label = button.Value;

            if (!isDefined(button.Value))
                button.Value = "";
        }
        return widgetData;
    }
    // ------------------------------------------------------------------------------------------------
    public GetLocalizationDictionary() {
        const res = ButtonsWidget.GetLocalizationDictionaryStatic(this.WidgetData);

        if (!IsNullOrEmpty(this.Description.WidgetTitle))
            res[WidgetsThingsStructs.WidgetLocalizationKeys.Title] = this.Description.WidgetTitle;

        return res;
    }
    // ------------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------